import React from 'react'
import { Box } from '@mui/material'
import { OrgRole } from 'pure-js/types/OrganizationMembership'

import { INTERAX_COLORS } from '../../../constants/colors'
import { useTranslation } from '../../../shared/hooks/useIntractionTranslate'
import { orgRoleTranslationKey } from '../orgTranslationKeys'

type Tone = { bg: string; fg: string; border: string }

const TONES: Record<OrgRole, Tone> = {
  [OrgRole.ADMIN]: {
    bg: INTERAX_COLORS.sun20,
    fg: INTERAX_COLORS.sun,
    border: INTERAX_COLORS.sun40
  },
  [OrgRole.FACILITATOR]: {
    bg: INTERAX_COLORS.heritageBlue40,
    fg: INTERAX_COLORS.white,
    border: INTERAX_COLORS.white10
  },
  [OrgRole.LEADER]: {
    bg: INTERAX_COLORS.blueBackground,
    fg: INTERAX_COLORS.blue,
    border: INTERAX_COLORS.blueBackground
  },
  [OrgRole.GAMER]: {
    bg: INTERAX_COLORS.white10,
    fg: INTERAX_COLORS.white70,
    border: INTERAX_COLORS.white10
  }
}

export const OrgRoleChip: React.FC<{ role: OrgRole; size?: 'small' | 'medium' }> = ({ role, size = 'medium' }) => {
  const { t } = useTranslation()
  const tone = TONES[role]
  const py = size === 'small' ? 0.25 : 0.5
  const px = size === 'small' ? 1 : 1.25
  const fontSize = size === 'small' ? 11 : 12

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        px,
        py,
        borderRadius: 999,
        backgroundColor: tone.bg,
        color: tone.fg,
        border: `1px solid ${tone.border}`,
        fontSize,
        fontWeight: 600,
        letterSpacing: 0.3,
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        lineHeight: 1.4
      }}
    >
      {t(orgRoleTranslationKey(role))}
    </Box>
  )
}
